import React, { useEffect, useState } from 'react';
import { apiFetch } from './api';

const EMPTY_CUSTOMER = { name: '', email: '', phone: '', address: '', cep: '', street: '', number: '', neighborhood: '', city: '', state: '' };
const EMPTY_VEHICLE  = { plate: '', model: '', year: '', current_km: '' };

const POPULAR_MODELS = [
  "CHEVROLET ONIX", "CHEVROLET PRISMA", "CHEVROLET CRUZE", "CHEVROLET S10", "CHEVROLET TRACKER", "CHEVROLET SPIN", "CHEVROLET MONTANA", "CHEVROLET COBALT", "CHEVROLET CELTA", "CHEVROLET CORSA", "CHEVROLET ASTRA", "CHEVROLET VECTRA",
  "VOLKSWAGEN GOL", "VOLKSWAGEN POLO", "VOLKSWAGEN T-CROSS", "VOLKSWAGEN NIVUS", "VOLKSWAGEN VIRTUS", "VOLKSWAGEN AMAROK", "VOLKSWAGEN VOYAGE", "VOLKSWAGEN SAVEIRO", "VOLKSWAGEN FOX", "VOLKSWAGEN JETTA", "VOLKSWAGEN TIGUAN", "VOLKSWAGEN GOLF", "VOLKSWAGEN UP!",
  "FIAT STRADA", "FIAT TORO", "FIAT ARGO", "FIAT MOBI", "FIAT CRONOS", "FIAT PULSE", "FIAT FASTBACK", "FIAT UNO", "FIAT PALIO", "FIAT SIENA", "FIAT FIORINO", "FIAT DUCATO", "FIAT PUNTO", "FIAT LINEA", "FIAT BRAVO",
  "FORD KA", "FORD RANGER", "FORD ECOSPORT", "FORD FIESTA", "FORD FOCUS", "FORD FUSION", "FORD TERRITORY", "FORD MAVERICK", "FORD BRONCO",
  "HYUNDAI HB20", "HYUNDAI HB20S", "HYUNDAI CRETA", "HYUNDAI TUCSON", "HYUNDAI IX35", "HYUNDAI SANTA FE", "HYUNDAI AZERA", "HYUNDAI HR",
  "TOYOTA COROLLA", "TOYOTA HILUX", "TOYOTA YARIS", "TOYOTA COROLLA CROSS", "TOYOTA SW4", "TOYOTA ETIOS", "TOYOTA RAV4", "TOYOTA CAMRY",
  "HONDA CIVIC", "HONDA FIT", "HONDA HR-V", "HONDA CITY", "HONDA WR-V", "HONDA CR-V", "HONDA ACCORD",
  "JEEP COMPASS", "JEEP RENEGADE", "JEEP COMMANDER", "JEEP CHEROKEE", "JEEP WRANGLER",
  "NISSAN KICKS", "NISSAN FRONTIER", "NISSAN VERSA", "NISSAN MARCH", "NISSAN SENTRA", "NISSAN TIIDA",
  "RENAULT KWID", "RENAULT SANDERO", "RENAULT DUSTER", "RENAULT LOGAN", "RENAULT OROCH", "RENAULT MASTER", "RENAULT CAPTUR", "RENAULT CLIO",
  "PEUGEOT 208", "PEUGEOT 2008", "PEUGEOT 3008", "PEUGEOT PARTNER", "PEUGEOT EXPERT", "PEUGEOT 308", "PEUGEOT 408",
  "CITROEN C3", "CITROEN C4 CACTUS", "CITROEN C3 AIRCROSS", "CITROEN JUMPY", "CITROEN BERLINGO", "CITROEN C4 PALLAS",
  "MITSUBISHI L200", "MITSUBISHI ASX", "MITSUBISHI OUTLANDER", "MITSUBISHI PAJERO", "MITSUBISHI ECLIPSE CROSS",
  "CAOA CHERY TIGGO 5X", "CAOA CHERY TIGGO 7", "CAOA CHERY TIGGO 8", "CAOA CHERY ARRIZO 6", "CAOA CHERY iCAR",
  "BYD DOLPHIN", "BYD SEAL", "BYD SONG PLUS", "BYD YUAN PLUS", "BYD TAN",
  "GWM HAVAL H6", "GWM ORA 03",
  "BMW 320i", "BMW X1", "BMW X3", "BMW X5", "BMW 118i",
  "MERCEDES-BENZ CLASSE C", "MERCEDES-BENZ GLA", "MERCEDES-BENZ GLC", "MERCEDES-BENZ SPRINTER",
  "AUDI A3", "AUDI Q3", "AUDI A4", "AUDI Q5",
  "VOLVO XC40", "VOLVO XC60", "VOLVO XC90",
  "KIA SPORTAGE", "KIA CERATO", "KIA BONGO", "KIA STONIC",
  "HONDA CG 160", "HONDA BIZ 125", "HONDA NXR 160 BROS", "HONDA PCX", "HONDA CB 300F", "HONDA XRE 300", "HONDA CB 500", "HONDA CRF 250",
  "YAMAHA FACTOR 150", "YAMAHA FAZER 250", "YAMAHA MT-03", "YAMAHA XMAX", "YAMAHA NMAX", "YAMAHA LANDER 250", "YAMAHA CROSSER 150"
];

const btnSm = { padding: '5px 12px', fontSize: '0.78rem', borderRadius: '8px', border: 'none', cursor: 'pointer', fontWeight: '600' };

function Customers({ tenantId }) {
  const [customers, setCustomers]     = useState([]);
  const [ranking,   setRanking]       = useState([]);
  const [loading,   setLoading]       = useState(true);
  const [searchTerm, setSearchTerm]   = useState('');
  const [filter, setFilter]           = useState('');

  // modal novo cliente
  const [showNew,     setShowNew]     = useState(false);
  const [newCustomer, setNewCustomer] = useState(EMPTY_CUSTOMER);

  // perfil do cliente
  const [profile,     setProfile]     = useState(null);
  const [editForm,    setEditForm]    = useState(EMPTY_CUSTOMER);
  const [editMode,    setEditMode]    = useState(false);

  // veículos dentro do perfil
  const [vehicles,    setVehicles]    = useState([]);
  const [loadingVeh,  setLoadingVeh]  = useState(false);
  const [showNewVeh,  setShowNewVeh]  = useState(false);
  const [newVehicle,  setNewVehicle]  = useState(EMPTY_VEHICLE);
  const [savingVeh,   setSavingVeh]   = useState(false);
  const [editVeh,     setEditVeh]     = useState(null);
  const [editVehForm, setEditVehForm] = useState(EMPTY_VEHICLE);

  // painel CRM preditivo
  const [showCrmPanel,    setShowCrmPanel]    = useState(false);
  const [crmOpps,         setCrmOpps]         = useState([]);
  const [crmLoading,      setCrmLoading]      = useState(false);
  const [generatingMsg,   setGeneratingMsg]   = useState(null);
  const [generatedMsgs,   setGeneratedMsgs]   = useState({});
  const [copiedId,        setCopiedId]        = useState(null);

  // ── fetch ─────────────────────────────────────────────────────────────────
  const fetchData = () => {
    setLoading(true);
    Promise.all([
      apiFetch(`/customers?tenant_id=${tenantId}`),
      apiFetch(`/customers/ranking?tenant_id=${tenantId}`)
    ]).then(async ([cRes, rRes]) => {
      const cData = await cRes.json();
      const rData = await rRes.json();
      setCustomers(cData.customers || []);
      setRanking(rData.ranking || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  };

  useEffect(() => { fetchData(); }, [tenantId]); // eslint-disable-line

  const fetchVehicles = (customerId) => {
    setLoadingVeh(true);
    apiFetch(`/customers/${customerId}/vehicles?tenant_id=${tenantId}`)
      .then(r => r.json())
      .then(d => { setVehicles(d.vehicles || []); setLoadingVeh(false); })
      .catch(() => setLoadingVeh(false));
  };

  // ── perfil ────────────────────────────────────────────────────────────────
  const openProfile = (cust, startEdit = false) => {
    const c = {
      id: cust[0], name: cust[1], phone: cust[2] || '',
      email: cust[3] || '', created_at: cust[4],
      points: cust[5] || 0, address: cust[6] || '',
      cep: cust[7] || '', street: cust[8] || '', number: cust[9] || '',
      neighborhood: cust[10] || '', city: cust[11] || '', state: cust[12] || ''
    };
    setProfile(c);
    setEditForm({ name: c.name, email: c.email, phone: c.phone, address: c.address, cep: c.cep, street: c.street, number: c.number, neighborhood: c.neighborhood, city: c.city, state: c.state });
    setEditMode(startEdit);
    setShowNewVeh(false);
    setEditVeh(null);
    fetchVehicles(c.id);
  };

  const closeProfile = () => {
    setProfile(null);
    setVehicles([]);
    setEditMode(false);
    setShowNewVeh(false);
    setEditVeh(null);
  };

  // ── CRM Preditivo ─────────────────────────────────────────────────────────
  const openCrmPanel = async () => {
    setShowCrmPanel(true);
    setCrmLoading(true);
    setCrmOpps([]);
    try {
      const res = await apiFetch(`/crm/opportunities?tenant_id=${tenantId}`);
      if (res.ok) {
        const data = await res.json();
        setCrmOpps(data.opportunities || data || []);
      } else {
        setCrmOpps([]);
      }
    } catch {
      setCrmOpps([]);
    } finally {
      setCrmLoading(false);
    }
  };

  const generateMessage = async (opp) => {
    setGeneratingMsg(opp.id || opp.customer_id);
    try {
      const res = await apiFetch(`/crm/generate-message?tenant_id=${tenantId}`, {
        method: 'POST',
        body: JSON.stringify(opp),
      });
      if (res.ok) {
        const data = await res.json();
        const msg = data.message || data.texto || data.result || JSON.stringify(data);
        setGeneratedMsgs(prev => ({ ...prev, [opp.id || opp.customer_id]: msg }));
      }
    } catch {
      // silently ignore
    } finally {
      setGeneratingMsg(null);
    }
  };

  const copyMessage = (id, text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedId(id);
      setTimeout(() => setCopiedId(null), 2000);
    });
  };

  // ── CRUD cliente ──────────────────────────────────────────────────────────
  const handleCreate = async (e) => {
    e.preventDefault();
    const res = await apiFetch(`/customers?tenant_id=${tenantId}`, {
      method: 'POST', body: JSON.stringify(newCustomer)
    });
    if (res.ok) { setShowNew(false); setNewCustomer(EMPTY_CUSTOMER); fetchData(); }
    else alert('Erro ao cadastrar cliente.');
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const res = await apiFetch(`/customers/${profile.id}?tenant_id=${tenantId}`, {
      method: 'PUT', body: JSON.stringify(editForm)
    });
    if (res.ok) {
      setEditMode(false);
      setProfile(p => ({ ...p, ...editForm }));
      fetchData();
      closeProfile();
    } else alert('Erro ao atualizar cliente.');
  };

  // ── CRUD veículo ──────────────────────────────────────────────────────────
  const handleAddVehicle = async (e) => {
    e.preventDefault();
    setSavingVeh(true);
    const res = await apiFetch(`/vehicles?tenant_id=${tenantId}`, {
      method: 'POST',
      body: JSON.stringify({
        ...newVehicle,
        year: newVehicle.year ? parseInt(newVehicle.year) : null,
        current_km: newVehicle.current_km ? parseInt(newVehicle.current_km) : null,
        customer_id: profile.id
      })
    });
    setSavingVeh(false);
    if (res.ok) { setShowNewVeh(false); setNewVehicle(EMPTY_VEHICLE); fetchVehicles(profile.id); closeProfile(); }
    else alert('Erro ao cadastrar veículo.');
  };

  const handleUpdateVehicle = async (e) => {
    e.preventDefault();
    const res = await apiFetch(`/vehicles/${editVeh.id}?tenant_id=${tenantId}`, {
      method: 'PUT',
      body: JSON.stringify({
        ...editVehForm,
        year: editVehForm.year ? parseInt(editVehForm.year) : null,
        current_km: editVehForm.current_km ? parseInt(editVehForm.current_km) : null,
        customer_id: profile.id
      })
    });
    if (res.ok) { setEditVeh(null); fetchVehicles(profile.id); closeProfile(); }
    else alert('Erro ao atualizar veículo.');
  };

  const startEditVeh = (v) => {
    setEditVeh(v);
    setEditVehForm({ plate: v.plate, model: v.model, year: v.year || '', current_km: v.current_km || '' });
    setShowNewVeh(false);
  };

  const getInitials = (name) => {
    if (!name) return '??';
    return name.split(' ').map(n => n[0]).join('').substring(0,2).toUpperCase();
  };

  const fetchCep = async (cep, isEdit = false) => {
    const cleanCep = cep.replace(/\D/g, '');
    if (cleanCep.length === 8) {
      try {
        const res = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`);
        const data = await res.json();
        if (!data.erro) {
          if (isEdit) {
            setEditForm(prev => ({ ...prev, street: data.logradouro, neighborhood: data.bairro, city: data.localidade, state: data.uf }));
          } else {
            setNewCustomer(prev => ({ ...prev, street: data.logradouro, neighborhood: data.bairro, city: data.localidade, state: data.uf }));
          }
        }
      } catch (error) {
        console.error("Erro ao buscar CEP:", error);
      }
    }
  };

  const isVIP = (points) => (points || 0) >= 500;
  const isNew = (dateStr) => {
    const d = new Date(dateStr);
    const now = new Date();
    return (now - d) < 1000 * 60 * 60 * 24 * 30; // 30 days
  };

  // ── render ────────────────────────────────────────────────────────────────
  if (loading) return <div className="stat-label">Carregando clientes...</div>;

  const filteredCustomers = customers.filter(c => {
    const nameMatch = c[1].toLowerCase().includes(searchTerm.toLowerCase());
    const phoneMatch = c[2] && c[2].includes(searchTerm);
    if (!nameMatch && !phoneMatch) return false;
    
    if (filter === 'vip' && !isVIP(c[5])) return false;
    if (filter === 'novo' && !isNew(c[4])) return false;
    
    return true;
  });

  return (
    <div className="animate-fade">
      <div className="header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <div>
          <h2 style={{ fontSize: '1.5rem', fontWeight: '700' }}>Clientes</h2>
          <p style={{ color: 'var(--gray)', fontSize: '0.875rem' }}>Base de clientes e portal de fidelidade.</p>
        </div>
        <div>
          <button className="btn-primary" style={{ padding: '0.75rem 1.25rem', borderRadius: '10px' }} onClick={() => setShowNew(true)}>
            <i className="fas fa-user-plus" style={{marginRight: '8px'}}></i> Novo Cliente
          </button>
        </div>
      </div>

      {/* ── Stats ── */}
      <div className="stats-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1rem', marginBottom: '2rem' }}>
        {[
          { icon: 'fa-address-book',  bg: filter === ''    ? 'var(--primary)'  : 'rgb(14 165 233 / 0.1)',  color: filter === ''    ? 'white' : 'var(--primary)',  activeBg: 'rgb(14 165 233 / 0.05)',  activeBorder: 'var(--primary)',  value: customers.length,                                label: 'Total de Clientes',   key: '',    onClick: () => setFilter('') },
          { icon: 'fa-user-clock',    bg: filter === 'novo'? 'var(--success)'  : 'rgb(16 185 129 / 0.1)',  color: filter === 'novo'? 'white' : 'var(--success)',  activeBg: 'rgb(16 185 129 / 0.05)',  activeBorder: 'var(--success)',  value: customers.filter(c => isNew(c[4])).length,       label: 'Novos (30 dias)',     key: 'novo', onClick: () => setFilter(filter === 'novo' ? '' : 'novo') },
          { icon: 'fa-star',          bg: filter === 'vip' ? 'var(--warning)'  : 'rgb(245 158 11 / 0.1)',  color: filter === 'vip' ? 'white' : 'var(--warning)',  activeBg: 'rgb(245 158 11 / 0.05)',  activeBorder: 'var(--warning)',  value: customers.filter(c => isVIP(c[5])).length,       label: 'Clientes VIP',        key: 'vip',  onClick: () => setFilter(filter === 'vip'  ? '' : 'vip')  },
          { icon: 'fa-robot',         bg: 'rgb(139 92 246 / 0.1)',              color: '#7c3aed',                                                             activeBg: 'var(--white)',            activeBorder: 'transparent',    value: 'CRM',                                           label: 'Automação Ativa',     key: null,   onClick: () => openCrmPanel() },
        ].map((s, i) => (
          <div
            key={i}
            onClick={s.onClick}
            style={{
              cursor: s.onClick ? 'pointer' : 'default',
              background: s.key !== null && filter === s.key ? s.activeBg : 'var(--white)',
              border: `2px solid ${s.key !== null && filter === s.key ? s.activeBorder : 'transparent'}`,
              padding: '0.875rem 1.1rem',
              borderRadius: '14px',
              boxShadow: 'var(--shadow)',
              transition: 'all 0.2s',
              display: 'flex',
              alignItems: 'center',
              gap: '0.875rem',
            }}
          >
            <div style={{ width: '42px', height: '42px', borderRadius: '11px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem', flexShrink: 0, background: s.bg, color: s.color, transition: 'all 0.2s' }}>
              <i className={`fas ${s.icon}`}></i>
            </div>
            <div>
              <div style={{ fontSize: '1.5rem', fontWeight: '700', lineHeight: 1.1 }}>{s.value}</div>
              <div style={{ fontSize: '0.78rem', color: 'var(--gray)', marginTop: '2px' }}>{s.label}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="toolbar" style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
        <div className="search-box" style={{ flex: 1, position: 'relative', minWidth: '250px' }}>
          <i className="fas fa-search" style={{ position: 'absolute', left: '1rem', top: '50%', transform: 'translateY(-50%)', color: 'var(--gray)' }}></i>
          <input type="text" placeholder="Buscar por nome ou telefone..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} style={{ width: '100%', padding: '0.625rem 1rem 0.625rem 2.5rem', border: '2px solid #e2e8f0', borderRadius: '10px', fontSize: '0.875rem' }} />
        </div>
        <select className="filter-select" value={filter} onChange={e => setFilter(e.target.value)} style={{ padding: '0.625rem 2.5rem 0.625rem 1rem', border: '2px solid #e2e8f0', borderRadius: '10px', fontSize: '0.875rem', background: 'white', cursor: 'pointer' }}>
          <option value="">Todos</option>
          <option value="vip">VIP</option>
          <option value="novo">Novos</option>
        </select>
      </div>

      <div className="client-grid">
        {filteredCustomers.map(cust => (
          <div className="client-card" key={cust[0]} onClick={() => openProfile(cust)}>
            <div className="client-header">
              <div className="client-avatar">
                {getInitials(cust[1])}
              </div>
              <div className="client-info">
                <h4>{cust[1]}</h4>
                <p>{cust[2] || 'Sem telefone'}</p>
                <div className="client-tags">
                  {isVIP(cust[5]) && <span className="tag vip"><i className="fas fa-crown"></i> VIP</span>}
                  {isNew(cust[4]) && <span className="tag novo">Novo</span>}
                </div>
              </div>
            </div>
            <div className="client-meta">
              <div className="client-meta-item">
                <div className="value">{cust[5] || 0}</div>
                <div className="label">Pontos</div>
              </div>
              <div className="client-meta-item">
                <div className="value" style={{ color: 'var(--success)' }}>
                  {new Date(cust[4]).toLocaleDateString('pt-BR')}
                </div>
                <div className="label">Desde</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* ── Slide-over Detail Panel ── */}
      <div className={`overlay-backdrop ${profile ? 'active' : ''}`} onClick={closeProfile}></div>
      <div className={`detail-panel ${profile ? 'open' : ''}`}>
        {profile && (
          <>
            <div className="detail-header" style={{ padding: '1.5rem', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fff', position: 'sticky', top: 0, zIndex: 10 }}>
              <h3 style={{ fontSize: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <div className="client-avatar" style={{ width: '40px', height: '40px', fontSize: '1rem' }}>{getInitials(profile.name)}</div>
                Perfil do Cliente
              </h3>
              <button className="close-btn" onClick={closeProfile} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: 'var(--gray)' }}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="detail-body" style={{ padding: '1.5rem' }}>
              
              {!editMode ? (
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                    <h4 style={{ fontSize: '1.1rem' }}>Dados Pessoais</h4>
                    <button className="btn-outline btn-sm" onClick={() => setEditMode(true)} style={btnSm}><i className="fas fa-edit"></i> Editar</button>
                  </div>
                  <div style={{ background: 'var(--light)', padding: '1.25rem', borderRadius: '12px', marginBottom: '2rem' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                      <div><span style={{ fontSize: '0.75rem', color: 'var(--gray)', textTransform: 'uppercase' }}>Nome</span><br/><strong>{profile.name}</strong></div>
                      <div><span style={{ fontSize: '0.75rem', color: 'var(--gray)', textTransform: 'uppercase' }}>Telefone</span><br/><strong>{profile.phone || '-'}</strong></div>
                      <div><span style={{ fontSize: '0.75rem', color: 'var(--gray)', textTransform: 'uppercase' }}>E-mail</span><br/><strong>{profile.email || '-'}</strong></div>
                      <div><span style={{ fontSize: '0.75rem', color: 'var(--gray)', textTransform: 'uppercase' }}>Fidelidade</span><br/><strong style={{ color: 'var(--warning)' }}>{profile.points} pts</strong></div>
                      <div style={{ gridColumn: '1 / -1' }}>
                        <span style={{ fontSize: '0.75rem', color: 'var(--gray)', textTransform: 'uppercase' }}>Endereço Completo</span><br/>
                        <strong>{profile.street ? `${profile.street}, ${profile.number} - ${profile.neighborhood}, ${profile.city}/${profile.state} - CEP: ${profile.cep}` : profile.address || '-'}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <form onSubmit={handleUpdate} style={{ background: 'var(--light)', padding: '1.25rem', borderRadius: '12px', marginBottom: '2rem' }}>
                  <h4 style={{ marginBottom: '1rem', fontSize: '1.1rem' }}>Editar Dados</h4>
                  <div className="form-group" style={{ marginBottom: '1rem' }}>
                    <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem' }}>Nome</label>
                    <input type="text" required value={editForm.name} onChange={e=>setEditForm({...editForm, name: e.target.value})} style={{ width: '100%', padding: '0.625rem 0.875rem', border: '2px solid #e2e8f0', borderRadius: '10px' }} />
                  </div>
                  <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
                    <div className="form-group">
                      <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem' }}>Telefone</label>
                      <input type="text" value={editForm.phone} onChange={e=>setEditForm({...editForm, phone: e.target.value})} style={{ width: '100%', padding: '0.625rem 0.875rem', border: '2px solid #e2e8f0', borderRadius: '10px' }} />
                    </div>
                    <div className="form-group">
                      <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem' }}>E-mail</label>
                      <input type="email" value={editForm.email} onChange={e=>setEditForm({...editForm, email: e.target.value})} style={{ width: '100%', padding: '0.625rem 0.875rem', border: '2px solid #e2e8f0', borderRadius: '10px' }} />
                    </div>
                  </div>
                  <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '1rem', marginBottom: '1rem' }}>
                    <div className="form-group">
                      <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem' }}>CEP</label>
                      <input type="text" value={editForm.cep} onChange={e=>{
                        setEditForm({...editForm, cep: e.target.value});
                        if(e.target.value.length >= 8) fetchCep(e.target.value, true);
                      }} style={{ width: '100%', padding: '0.625rem 0.875rem', border: '2px solid #e2e8f0', borderRadius: '10px' }} />
                    </div>
                    <div className="form-group">
                      <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem' }}>Rua</label>
                      <input type="text" value={editForm.street} onChange={e=>setEditForm({...editForm, street: e.target.value})} style={{ width: '100%', padding: '0.625rem 0.875rem', border: '2px solid #e2e8f0', borderRadius: '10px' }} />
                    </div>
                  </div>
                  <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '1rem', marginBottom: '1rem' }}>
                    <div className="form-group">
                      <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem' }}>Número</label>
                      <input type="text" value={editForm.number} onChange={e=>setEditForm({...editForm, number: e.target.value})} style={{ width: '100%', padding: '0.625rem 0.875rem', border: '2px solid #e2e8f0', borderRadius: '10px' }} />
                    </div>
                    <div className="form-group">
                      <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem' }}>Bairro</label>
                      <input type="text" value={editForm.neighborhood} onChange={e=>setEditForm({...editForm, neighborhood: e.target.value})} style={{ width: '100%', padding: '0.625rem 0.875rem', border: '2px solid #e2e8f0', borderRadius: '10px' }} />
                    </div>
                  </div>
                  <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
                    <div className="form-group">
                      <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem' }}>Cidade</label>
                      <input type="text" value={editForm.city} onChange={e=>setEditForm({...editForm, city: e.target.value})} style={{ width: '100%', padding: '0.625rem 0.875rem', border: '2px solid #e2e8f0', borderRadius: '10px' }} />
                    </div>
                    <div className="form-group">
                      <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem' }}>UF</label>
                      <input type="text" maxLength={2} value={editForm.state} onChange={e=>setEditForm({...editForm, state: e.target.value.toUpperCase()})} style={{ width: '100%', padding: '0.625rem 0.875rem', border: '2px solid #e2e8f0', borderRadius: '10px' }} />
                    </div>
                  </div>
                  <div className="form-group" style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.5rem' }}>Complemento/Endereço Antigo</label>
                    <input type="text" value={editForm.address} onChange={e=>setEditForm({...editForm, address: e.target.value})} style={{ width: '100%', padding: '0.625rem 0.875rem', border: '2px solid #e2e8f0', borderRadius: '10px' }} />
                  </div>
                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <button type="submit" className="btn-primary" style={btnSm}>Salvar Alterações</button>
                    <button type="button" className="btn-outline" style={btnSm} onClick={() => setEditMode(false)}>Cancelar</button>
                  </div>
                </form>
              )}

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                <h4 style={{ fontSize: '1.1rem' }}>Veículos da Garagem</h4>
                <button className="btn-success btn-sm" onClick={() => { setShowNewVeh(true); setEditVeh(null); }} style={btnSm}>
                  <i className="fas fa-plus"></i> Veículo
                </button>
              </div>

              {showNewVeh && (
                <form onSubmit={handleAddVehicle} style={{ background: 'var(--light)', padding: '1.25rem', borderRadius: '12px', marginBottom: '1.5rem', borderLeft: '4px solid var(--success)' }}>
                  <h5 style={{ marginBottom: '0.75rem' }}>Cadastrar Novo Veículo</h5>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
                    <div>
                      <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '600', color: 'var(--gray)', marginBottom: '0.25rem' }}>Placa</label>
                      <input type="text" required placeholder="ABC1234" value={newVehicle.plate} onChange={e=>setNewVehicle({...newVehicle, plate: e.target.value.toUpperCase()})} style={{ width: '100%', padding: '0.625rem', border: '2px solid #e2e8f0', borderRadius: '8px', boxSizing: 'border-box' }} />
                    </div>
                    <div>
                      <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '600', color: 'var(--gray)', marginBottom: '0.25rem' }}>Modelo / Marca</label>
                      <input type="text" required list="car-models-list-new" placeholder="Ex: HONDA CIVIC" value={newVehicle.model} onChange={e=>setNewVehicle({...newVehicle, model: e.target.value.toUpperCase()})} style={{ width: '100%', padding: '0.625rem', border: '2px solid #e2e8f0', borderRadius: '8px', boxSizing: 'border-box' }} />
                      <datalist id="car-models-list-new">
                        {POPULAR_MODELS.map(m => <option key={m} value={m} />)}
                      </datalist>
                    </div>
                    <div>
                      <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '600', color: 'var(--gray)', marginBottom: '0.25rem' }}>Ano</label>
                      <input type="number" placeholder="Ex: 2024" value={newVehicle.year} onChange={e=>setNewVehicle({...newVehicle, year: e.target.value})} style={{ width: '100%', padding: '0.625rem', border: '2px solid #e2e8f0', borderRadius: '8px', boxSizing: 'border-box' }} />
                    </div>
                    <div>
                      <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '600', color: 'var(--gray)', marginBottom: '0.25rem' }}>KM Atual</label>
                      <input type="number" placeholder="Ex: 45000" value={newVehicle.current_km} onChange={e=>setNewVehicle({...newVehicle, current_km: e.target.value})} style={{ width: '100%', padding: '0.625rem', border: '2px solid #e2e8f0', borderRadius: '8px', boxSizing: 'border-box' }} />
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <button type="submit" disabled={savingVeh} className="btn-success" style={btnSm}>{savingVeh ? 'Salvando...' : 'Salvar Veículo'}</button>
                    <button type="button" className="btn-outline" onClick={() => setShowNewVeh(false)} style={btnSm}>Cancelar</button>
                  </div>
                </form>
              )}

              {loadingVeh ? (
                <p style={{ fontSize: '0.875rem', color: 'var(--gray)' }}>Carregando veículos...</p>
              ) : vehicles.length === 0 ? (
                <div style={{ background: '#f8fafc', border: '2px dashed #cbd5e1', padding: '2rem', textAlign: 'center', borderRadius: '12px' }}>
                  <i className="fas fa-car" style={{ fontSize: '2rem', color: '#94a3b8', marginBottom: '0.5rem' }}></i>
                  <p style={{ color: 'var(--gray)', fontSize: '0.875rem' }}>Nenhum veículo cadastrado para este cliente.</p>
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                  {vehicles.map(v => (
                    <div key={v.id} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}>
                      {editVeh && editVeh.id === v.id ? (
                        <form onSubmit={handleUpdateVehicle} style={{ padding: '1.25rem', background: '#f8fafc' }}>
                          <h5 style={{ marginBottom: '0.75rem' }}>Editando Veículo</h5>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
                            <div>
                              <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '600', color: 'var(--gray)', marginBottom: '0.25rem' }}>Placa</label>
                              <input type="text" required value={editVehForm.plate} onChange={e=>setEditVehForm({...editVehForm, plate: e.target.value.toUpperCase()})} style={{ width: '100%', padding: '0.625rem', border: '2px solid #e2e8f0', borderRadius: '8px', boxSizing: 'border-box' }} />
                            </div>
                            <div>
                              <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '600', color: 'var(--gray)', marginBottom: '0.25rem' }}>Modelo / Marca</label>
                              <input type="text" required list="car-models-list-edit" value={editVehForm.model} onChange={e=>setEditVehForm({...editVehForm, model: e.target.value.toUpperCase()})} style={{ width: '100%', padding: '0.625rem', border: '2px solid #e2e8f0', borderRadius: '8px', boxSizing: 'border-box' }} />
                              <datalist id="car-models-list-edit">
                                {POPULAR_MODELS.map(m => <option key={m} value={m} />)}
                              </datalist>
                            </div>
                            <div>
                              <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '600', color: 'var(--gray)', marginBottom: '0.25rem' }}>Ano</label>
                              <input type="number" value={editVehForm.year} onChange={e=>setEditVehForm({...editVehForm, year: e.target.value})} style={{ width: '100%', padding: '0.625rem', border: '2px solid #e2e8f0', borderRadius: '8px', boxSizing: 'border-box' }} />
                            </div>
                            <div>
                              <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: '600', color: 'var(--gray)', marginBottom: '0.25rem' }}>KM Atual</label>
                              <input type="number" placeholder="KM Atual" value={editVehForm.current_km} onChange={e=>setEditVehForm({...editVehForm, current_km: e.target.value})} style={{ width: '100%', padding: '0.625rem', border: '2px solid #e2e8f0', borderRadius: '8px', boxSizing: 'border-box' }} />
                            </div>
                          </div>
                          <div style={{ display: 'flex', gap: '0.5rem' }}>
                            <button type="submit" className="btn-primary" style={btnSm}>Salvar</button>
                            <button type="button" className="btn-outline" onClick={() => setEditVeh(null)} style={btnSm}>Cancelar</button>
                          </div>
                        </form>
                      ) : (
                        <div style={{ display: 'flex', alignItems: 'stretch' }}>
                          <div style={{ background: 'linear-gradient(135deg, #1e293b, #334155)', width: '8px' }}></div>
                          <div style={{ padding: '1.25rem', flex: 1 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                              <div>
                                <h5 style={{ fontSize: '1.1rem', marginBottom: '0.25rem' }}>{v.model} <span style={{ fontSize: '0.8rem', color: 'var(--gray)', fontWeight: 'normal' }}>{v.year}</span></h5>
                                <div style={{ display: 'inline-block', background: '#ffeb3b', color: '#1a1a1a', padding: '0.25rem 0.6rem', borderRadius: '6px', fontWeight: '700', fontSize: '0.8rem', letterSpacing: '1px' }}>
                                  {v.plate}
                                </div>
                                {v.current_km ? (
                                  <div style={{ marginTop: '0.35rem', fontSize: '0.75rem', color: 'var(--gray)' }}>
                                    <i className="fas fa-tachometer-alt" style={{ marginRight: '4px' }}></i>
                                    {Number(v.current_km).toLocaleString('pt-BR')} km
                                  </div>
                                ) : null}
                              </div>
                              <button className="btn-outline btn-sm" onClick={() => startEditVeh(v)} style={{ padding: '0.35rem 0.6rem', fontSize: '0.75rem', borderRadius: '6px' }}><i className="fas fa-edit"></i></button>
                            </div>
                            <div style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid #f1f5f9', display: 'flex', gap: '0.5rem' }}>
                              <div className="vehicle-alert ok" style={{ margin: 0, padding: '0.4rem 0.6rem', fontSize: '0.7rem' }}>
                                <i className="fas fa-check-circle"></i> Tudo em dia
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}

            </div>
          </>
        )}
      </div>

      {/* ── Modal Novo Cliente ── */}
      {showNew && (
        <div className="modal-overlay active">
          <div className="modal">
            <div className="modal-header">
              <h3>Novo Cliente</h3>
              <button className="close-btn" onClick={() => setShowNew(false)}><i className="fas fa-times"></i></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleCreate}>
                <div className="form-group">
                  <label>Nome Completo</label>
                  <input type="text" required placeholder="Ex: João da Silva" value={newCustomer.name} onChange={e=>setNewCustomer({...newCustomer, name: e.target.value})} />
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Telefone</label>
                    <input type="text" placeholder="Ex: (11) 99999-9999" value={newCustomer.phone} onChange={e=>setNewCustomer({...newCustomer, phone: e.target.value})} />
                  </div>
                  <div className="form-group">
                    <label>E-mail</label>
                    <input type="email" placeholder="Ex: joao@email.com" value={newCustomer.email} onChange={e=>setNewCustomer({...newCustomer, email: e.target.value})} />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>CEP</label>
                    <input type="text" placeholder="Apenas números" value={newCustomer.cep} onChange={e=>{
                      setNewCustomer({...newCustomer, cep: e.target.value});
                      if(e.target.value.length >= 8) fetchCep(e.target.value, false);
                    }} />
                  </div>
                  <div className="form-group">
                    <label>Rua</label>
                    <input type="text" value={newCustomer.street} onChange={e=>setNewCustomer({...newCustomer, street: e.target.value})} />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Número</label>
                    <input type="text" value={newCustomer.number} onChange={e=>setNewCustomer({...newCustomer, number: e.target.value})} />
                  </div>
                  <div className="form-group">
                    <label>Bairro</label>
                    <input type="text" value={newCustomer.neighborhood} onChange={e=>setNewCustomer({...newCustomer, neighborhood: e.target.value})} />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Cidade</label>
                    <input type="text" value={newCustomer.city} onChange={e=>setNewCustomer({...newCustomer, city: e.target.value})} />
                  </div>
                  <div className="form-group">
                    <label>UF</label>
                    <input type="text" maxLength={2} value={newCustomer.state} onChange={e=>setNewCustomer({...newCustomer, state: e.target.value.toUpperCase()})} />
                  </div>
                </div>
                <div className="form-group">
                  <label>Complemento/Outros</label>
                  <input type="text" placeholder="Ex: Apto 12" value={newCustomer.address} onChange={e=>setNewCustomer({...newCustomer, address: e.target.value})} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '1.5rem' }}>
                  <button type="button" className="btn-outline" onClick={() => setShowNew(false)}>Cancelar</button>
                  <button type="submit" className="btn-primary">Salvar Cliente</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* ── Painel CRM Preditivo ── */}
      {showCrmPanel && (
        <>
          {/* Backdrop */}
          <div
            onClick={() => setShowCrmPanel(false)}
            style={{ position: 'fixed', inset: 0, zIndex: 490, background: 'rgba(15,23,42,0.55)', backdropFilter: 'blur(6px)', WebkitBackdropFilter: 'blur(6px)' }}
          />
          {/* Painel deslizante */}
          <div style={{
            position: 'fixed', top: 0, right: 0, bottom: 0, zIndex: 500,
            width: '100%', maxWidth: '480px',
            background: 'linear-gradient(160deg,#1e1b4b 0%,#2e1065 40%,#1a1a2e 100%)',
            boxShadow: '-8px 0 40px rgba(0,0,0,0.5)',
            display: 'flex', flexDirection: 'column',
            animation: 'aiSlideUp 0.28s cubic-bezier(0.34,1.26,0.64,1)',
            color: 'white',
          }}>

            {/* Header do painel */}
            <div style={{ padding: '1.5rem 1.75rem', borderBottom: '1px solid rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.875rem' }}>
                <div style={{ width: '44px', height: '44px', borderRadius: '12px', background: 'linear-gradient(135deg,#7c3aed,#ec4899)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.3rem', flexShrink: 0 }}>
                  <i className="fas fa-robot"></i>
                </div>
                <div>
                  <h3 style={{ margin: 0, fontSize: '1.05rem', fontWeight: '700' }}>Oportunidades Preditivas</h3>
                  <p style={{ margin: 0, fontSize: '0.78rem', color: 'rgba(255,255,255,0.5)' }}>CRM com Inteligência Artificial</p>
                </div>
              </div>
              <button
                onClick={() => setShowCrmPanel(false)}
                style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.8)', width: '36px', height: '36px', borderRadius: '50%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.9rem', flexShrink: 0 }}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>

            {/* Corpo */}
            <div style={{ flex: 1, overflowY: 'auto', padding: '1.5rem 1.75rem' }}>

              {crmLoading && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1.25rem', padding: '3rem 0' }}>
                  <div className="ai-spinner"></div>
                  <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.875rem', textAlign: 'center' }}>
                    Identificando clientes no momento ideal de contato...
                  </p>
                  <div style={{ display: 'flex', gap: '7px' }}>
                    {[0,1,2].map(i => <div key={i} className="ai-dot" style={{ animationDelay: `${i*0.22}s` }}></div>)}
                  </div>
                </div>
              )}

              {!crmLoading && crmOpps.length === 0 && (
                <div style={{ textAlign: 'center', padding: '3rem 0' }}>
                  <i className="fas fa-satellite-dish" style={{ fontSize: '2.5rem', color: 'rgba(167,139,250,0.5)', display: 'block', marginBottom: '1rem' }}></i>
                  <p style={{ fontWeight: '600', marginBottom: '0.5rem' }}>Nenhuma oportunidade no momento</p>
                  <p style={{ fontSize: '0.83rem', color: 'rgba(255,255,255,0.45)', marginBottom: '1.5rem' }}>
                    A rota <code style={{ background: 'rgba(255,255,255,0.08)', padding: '2px 6px', borderRadius: '4px' }}>/crm/opportunities</code> ainda será implementada no backend.
                  </p>
                  <button
                    onClick={openCrmPanel}
                    style={{ padding: '0.625rem 1.25rem', borderRadius: '10px', background: 'rgba(124,58,237,0.6)', border: '1px solid rgba(124,58,237,0.8)', color: 'white', cursor: 'pointer', fontWeight: '600', fontSize: '0.8rem' }}
                  >
                    <i className="fas fa-redo" style={{ marginRight: '6px' }}></i> Recarregar
                  </button>
                </div>
              )}

              {!crmLoading && crmOpps.map((opp, idx) => {
                const oppId = opp.id || opp.customer_id || idx;
                const msg   = generatedMsgs[oppId];
                const isGen = generatingMsg === oppId;
                const copied = copiedId === oppId;
                return (
                  <div key={oppId} style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '16px', padding: '1.25rem', marginBottom: '1rem' }}>

                    {/* Info do cliente/veículo */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.875rem' }}>
                      <div style={{ width: '42px', height: '42px', borderRadius: '50%', background: 'linear-gradient(135deg,#7c3aed,#ec4899)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700', fontSize: '1rem', flexShrink: 0 }}>
                        {(opp.customer_name || opp.name || '?')[0].toUpperCase()}
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <p style={{ margin: 0, fontWeight: '700', fontSize: '0.95rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {opp.customer_name || opp.name}
                        </p>
                        <p style={{ margin: 0, fontSize: '0.78rem', color: 'rgba(255,255,255,0.5)' }}>
                          {opp.vehicle_model || opp.model || ''}{opp.plate ? ` · ${opp.plate}` : ''}{opp.last_service_days ? ` · Último serviço: ${opp.last_service_days}d atrás` : ''}
                        </p>
                      </div>
                      {opp.score && (
                        <div style={{ background: 'rgba(74,222,128,0.15)', border: '1px solid rgba(74,222,128,0.3)', borderRadius: '8px', padding: '0.25rem 0.6rem', fontSize: '0.75rem', color: '#4ade80', fontWeight: '700', flexShrink: 0 }}>
                          {opp.score}%
                        </div>
                      )}
                    </div>

                    {/* Motivo da oportunidade */}
                    {opp.reason && (
                      <div style={{ background: 'rgba(250,204,21,0.1)', border: '1px solid rgba(250,204,21,0.2)', borderRadius: '10px', padding: '0.625rem 0.875rem', marginBottom: '0.875rem', fontSize: '0.8rem', color: 'rgba(255,255,255,0.8)', display: 'flex', gap: '0.5rem', alignItems: 'flex-start' }}>
                        <i className="fas fa-lightbulb" style={{ color: '#fbbf24', flexShrink: 0, marginTop: '1px' }}></i>
                        {opp.reason}
                      </div>
                    )}

                    {/* Botão Gerar Mensagem */}
                    {!msg && (
                      <button
                        disabled={isGen}
                        onClick={() => generateMessage(opp)}
                        style={{ width: '100%', padding: '0.625rem', borderRadius: '10px', background: isGen ? 'rgba(37,211,102,0.3)' : 'linear-gradient(135deg,#25d366,#128c7e)', border: 'none', color: 'white', fontWeight: '700', fontSize: '0.85rem', cursor: isGen ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', transition: 'opacity 0.2s' }}
                      >
                        {isGen ? (
                          <>
                            <div className="ai-dot" style={{ width: '6px', height: '6px', animationDelay: '0s' }}></div>
                            <div className="ai-dot" style={{ width: '6px', height: '6px', animationDelay: '0.2s' }}></div>
                            <div className="ai-dot" style={{ width: '6px', height: '6px', animationDelay: '0.4s' }}></div>
                          </>
                        ) : (
                          <>
                            <i className="fab fa-whatsapp" style={{ fontSize: '1rem' }}></i>
                            Gerar Mensagem Mágica
                          </>
                        )}
                      </button>
                    )}

                    {/* Mensagem gerada */}
                    {msg && (
                      <div>
                        <div style={{ background: 'rgba(37,211,102,0.08)', border: '1px solid rgba(37,211,102,0.25)', borderRadius: '10px', padding: '0.875rem', marginBottom: '0.75rem', fontSize: '0.85rem', lineHeight: '1.65', color: 'rgba(255,255,255,0.9)', whiteSpace: 'pre-wrap' }}>
                          {msg}
                        </div>
                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                          <button
                            onClick={() => copyMessage(oppId, msg)}
                            style={{ flex: 1, padding: '0.5rem', borderRadius: '8px', background: copied ? 'rgba(74,222,128,0.2)' : 'rgba(255,255,255,0.1)', border: `1px solid ${copied ? 'rgba(74,222,128,0.4)' : 'rgba(255,255,255,0.15)'}`, color: copied ? '#4ade80' : 'rgba(255,255,255,0.8)', fontWeight: '600', cursor: 'pointer', fontSize: '0.8rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.4rem', transition: 'all 0.2s' }}
                          >
                            <i className={`fas ${copied ? 'fa-check' : 'fa-copy'}`}></i>
                            {copied ? 'Copiado!' : 'Copiar'}
                          </button>
                          <button
                            onClick={() => {
                              const phone = (opp.phone || '').replace(/\D/g, '');
                              const url = `https://wa.me/55${phone}?text=${encodeURIComponent(msg)}`;
                              window.open(url, '_blank');
                            }}
                            style={{ flex: 1, padding: '0.5rem', borderRadius: '8px', background: 'linear-gradient(135deg,#25d366,#128c7e)', border: 'none', color: 'white', fontWeight: '700', cursor: 'pointer', fontSize: '0.8rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.4rem' }}
                          >
                            <i className="fab fa-whatsapp"></i> Enviar
                          </button>
                          <button
                            onClick={() => setGeneratedMsgs(prev => { const n = {...prev}; delete n[oppId]; return n; })}
                            style={{ padding: '0.5rem 0.75rem', borderRadius: '8px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.5)', cursor: 'pointer', fontSize: '0.8rem' }}
                            title="Gerar nova versão"
                          >
                            <i className="fas fa-redo"></i>
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}

            </div>
          </div>
        </>
      )}

    </div>
  );
}

export default Customers;
